import type { CanvasJSONLikeObject } from '@doer/frontend-components/creativity-editor';
import { TEXT_DEFAULTS, type FontWeight } from './text-defaults';

export interface PaymentMethodHighlightTextOpts {
  pieceId: string;
  text: string;
  fontSize: number;
  fontWeight?: FontWeight;
  position: { left: number; top: number; width: number; height: number };
  fill?: string;
  textAlign?: 'left' | 'center' | 'right';
  lineHeight?: number;
}

export function buildPaymentMethodHighlightText(opts: PaymentMethodHighlightTextOpts): CanvasJSONLikeObject {
  const {
    pieceId,
    text,
    fontSize,
    fontWeight = 'normal',
    position,
    fill = '#0030eb',
    textAlign = 'center',
    lineHeight = 1.16
  } = opts;
  return {
    ...TEXT_DEFAULTS,
    type: 'Textbox',
    pieceId,
    text,
    fontSize,
    fontWeight,
    lineHeight,
    textAlign,
    originY: 'center',
    left: position.left,
    top: position.top,
    width: position.width,
    height: position.height,
    fill,
    objectCaching: true
  };
}
